


























import { defineComponent, reactive, toRefs } from '@vue/composition-api'
import Alerts, { AlertType } from '../code/alerts'
import { HttpPOST, ValidateEmail } from '@/code/Utils'

export default defineComponent({
    name: 'Recuperacion',
    setup(props, context) {
        const data = reactive({
            cuil: '',
            email: ''
        })

        const Recover = async() => {
            if (data.email.trim() !== '' && data.cuil.trim() !== '') {

                if(!ValidateEmail(data.email)){
                    Alerts.Throw('Debe ingresar un email valido.', AlertType.Danger, false, 6000);
                    return;
                }

                const xml2 = `<?xml version="1.0" encoding="utf-8"?>
                                    <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
                                    <soap:Body>
                                        <RecuperarPassDDJJ xmlns="http://tempuri.org/">
                                        <mail>${data.email}</mail>
                                        <cuit>${data.cuil}</cuit>
                                        </RecuperarPassDDJJ>
                                    </soap:Body>
                                    </soap:Envelope>`

                const result = await HttpPOST(xml2, null) as XMLHttpRequest;
                console.log(result)
                console.log(result.responseText);

                if (result.statusText === "OK") {
                    const resultData = result.responseXML.getElementsByTagName("Data")[0].textContent.split("-");
                    if(resultData[0] != "No se ha encontrado el usuario."){
                        alert("Entro!!");
                        console.log(resultData);
                        const resultEMAIL = await HttpPOST(`<?xml version="1.0" encoding="utf-8"?>
                                                            <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
                                                                <soap12:Body>
                                                                <SendEmail xmlns="http://tempuri.org/">
                                                                    <To>${data.email}</To>
                                                                    <CC></CC>
                                                                    <Subject>Solicitud de recuperación de contraseña.</Subject>
                                                                    <Title>Recuperar Contraseña - Presentación DDJJ de ventas.</Title>
                                                                    <Content>Se ha creado una solicitud de recuperación de contraseña, ingrese al sistema de declaraciones con los siguientes datos:</Content>
                                                                    <Data>
                                                                    <string>CUIL/ Email-${data.cuil}/ ${data.email}</string>
                                                                    <string>Contraseña-${resultData[resultData.length - 1 ].split(":")[1].trim()}</string>
                                                                    </Data>
                                                                </SendEmail>
                                                                </soap12:Body>
                                                            </soap12:Envelope>`, window["ROOT_SERVICES"]) as XMLHttpRequest;
                        data.email = "";
                        data.cuil = "";
                        console.log(resultEMAIL);
                        Alerts.Throw(`Su nueva contraseña será enviada al email proporcionado dentro de unos minutos.
                                <br/><br/>
                                <a href="./"><b>Volver</b></a>`, AlertType.Info, true);  
                        }
                        else{
                            Alerts.Throw(`No se ha encontrado el usuario, favor ingrese los datos nuevamente.`, AlertType.Danger, false, 8000)        
                        }                   
                } else {
                    Alerts.Throw(`Ocurrió un error al enviar el mail de registro.<br><br>Por favor intente de nuevo en unos minutos.`, AlertType.Danger, false, 10000)
                }
            } else {
                Alerts.Throw('Por favor, verifique los campos para recuperar su contraseña.', AlertType.Danger, false, 6000);
            }
        }

        return {
            ...toRefs(data),
            Recover
        }
    }
});
